import { valid_email } from "../../common/utils";
import * as utils from "../utils";

import store from "../store";
import * as types from "./constants";

export function submitRsvp(data, captcha=null) {

  const form_data = Object.assign({}, data, {captcha: captcha && JSON.parse(captcha) || null});
  const url = `/ajax/event/${window.evite_event.id}/view/rsvp`;

  setFormSubmitting(true);

  $.post(url, form_data, (response) => {
    window.location = response.location;
  })
  .fail((xhr, status, data) => {
    setFormSubmitting(false);
    utils.handleCaptcha(xhr, status, data, function (captcha) {
      // Only submit the form again if captcha data is available
      captcha && submitRsvp(form_data, captcha);
    });
  });
}

export function showRsvpForm(show = true) {
  store.dispatch({
    show,
    type: types.SHOW_RSVP_FORM,
  });
}

export function toggleRsvpFormVisible(response) {
  store.dispatch({
    type: types.TOGGLE_RSVP_FORM_VISIBLE,
    response
  });
}

export function setFormSubmitting(submitting) {
  store.dispatch({
    type: types.SET_FORM_SUBMITTING,
    submitting
  });
}

export function setIncompleteGuest() {
  store.dispatch({
    type: types.SET_INCOMPLETE_GUEST
  });
}

export function setNotYou() {
  store.dispatch({
    type: types.SET_NOT_YOU
  });
}

export function unsetNotYou() {
  store.dispatch({
    type: types.UNSET_NOT_YOU
  });
}

export function setEditingGuestName(editing, guestName) {
  store.dispatch({
    type: types.SET_EDITING_GUEST_NAME,
    editing,
    guestName
  });
}

export function setGuestName(guestName) {
  store.dispatch({
    type: types.SET_GUEST_NAME,
    guestName
  });
}

export function setAltGuestName(altGuestName) {
  store.dispatch({
    type: types.SET_ALT_GUEST_NAME,
    altGuestName
  });
}

export function setGuestEmail(guestEmail) {
  store.dispatch({
    type: types.SET_GUEST_EMAIL,
    guestEmail
  });
}

export function getGuestEmail() {
  return store.getState().rsvp.guestEmail;
}

export function getMaxAdultCount() {
  const maxGuests = parseInt(store.getState().rsvp.maxGuests, 10);
  return maxGuests + 1;
}

export function getMinAdultCount() {
  return areKidsAllowed() ? 0 : 1;
}

export function setTotalAdults(adultCount) {
  adultCount = parseInt(adultCount, 10);
  if (!isNaN(adultCount)) {
    const maxCount = getMaxAdultCount();
    const minCount = getMinAdultCount();
    if (adultCount > maxCount) {
      adultCount = maxCount;
    } else if (adultCount < minCount) {
      adultCount = minCount;
    }
  }
  store.dispatch({
    type: types.SET_TOTAL_ADULTS,
    adultCount
  });
}

export function getTotalAdults() {
  return parseInt(store.getState().rsvp.totalAdults, 10);
}

function areKidsAllowed() {
    return store.getState().rsvp.allowKids;
}

export function setTotalKids(kidCount) {
  store.dispatch({
    type: types.SET_TOTAL_KIDS,
    kidCount
  });
}

export function setNotifyMarketing(notify) {
  store.dispatch({
    type: types.SET_NOTIFY_MARKETING,
    notify
  });
}

export function setRsvpComment(comment) {
  store.dispatch({
    type: types.SET_RSVP_COMMENT,
    comment
  });
}

export function setRsvpResponse(response) {
  store.dispatch({
    type: types.SET_RSVP_RESPONSE,
    response
  });
}


//-----------------------------------------------------------------------------
// functions for plus one stuff
export function setPlusOneEmailsStr(emailsStr) {
  store.dispatch({
    type: types.SET_PLUSONE_EMAILS,
    emailsStr
  });
}

export function getPlusOneEmailsStr() {
  return store.getState().rsvp.plusOneEmailsStr.trim();
}

export function setPlusOneEmails(emails) {
  setPlusOneEmailsStr(emails.join(', '));
}

export function getPlusOneEmails(emails) {
  let emailsStr = getPlusOneEmailsStr();
  if (! Boolean(emailsStr)) {
    return [];
  }
  return emailsStr.split(', ');
}

export function addEmailFromEditorContents(failIfBeyondMax=false) {
  const emailEntered = getPlusOneEditText();

  if (! Boolean(emailEntered)) {
    this.updateErrorMessage();
    return '';
  }

  const existingEmails = getPlusOneEmails();
  if (existingEmails.includes(emailEntered)) {
    const message = emailEntered + " is already present.";
    return message;
  }

  if (!valid_email(emailEntered).is_valid) {
    const message = emailEntered + " is not a valid email address.";
    return message;
  }

  if (getGuestEmail() == emailEntered) {
    return getPlusOneAlreadyOnGuestListMessageFor(emailEntered);
  }

  const errMsg = _addPlusOneEmail(emailEntered, failIfBeyondMax);
  if (!errMsg) {
    setPlusOneEditText('');
  }
  return errMsg;
}

export function getPlusOneAlreadyOnGuestListMessageFor(emailAddress) {
  return `${emailAddress} is already on the guest list. Enter the emails of your additional guests here.`;
}

function _addPlusOneEmail(email, failIfBeyondMax=false) {
  const currState = store.getState().rsvp;
  const currNumEmailsAllowed = currState.totalAdults - 1;
  let emails = getPlusOneEmails();
  emails.push(email);
  const numEmails = emails.length;
  const maxNumEmails = getMaxAdultCount() - 1;
  if (numEmails > maxNumEmails && failIfBeyondMax) {
    return `A maximum of ${maxNumEmails} email address${maxNumEmails > 1 ? 'es' : ''} can be added.`;
  }
  if (numEmails > currNumEmailsAllowed && numEmails <= maxNumEmails) {
    setTotalAdults(numEmails + 1);
  }
  setPlusOneEmails(emails);
  return '';
}

export function removePlusOneEmail(email) {
  let emails = getPlusOneEmails();
  const idx = emails.indexOf(email);
  if (idx == -1) {
    return; // not present
  }
  emails.splice(idx, 1);
  setPlusOneEmails(emails);
}

export function removeLastPlusOneEmail() {
  let emails = getPlusOneEmails();
  emails.pop();
  setPlusOneEmails(emails);
}

export function getPlusOneEditText() {
  return store.getState().rsvp.plusOneEditText.trim();
}

export function setPlusOneEditText(editTextStr) {
  store.dispatch({
    type: types.SET_PLUSONE_EDIT_TEXT,
    editTextStr
  });
}

export function toggleChangeRsvpVisible() {
  store.dispatch({
    type: types.TOGGLE_CHANGE_RSVP_VISIBLE,
  });
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/rsvp/actions.es6